import type { ModulePermissionShape } from "@/types/permissions";

export const structureAssignmentsPermissionKeys = [
  "structure_assignments_rr_to_rd_read",
  "structure_assignments_rr_to_fam_read",
  "structure_assignments_kam_to_csd_read",
] as const;

export type StructureAssignmentsPermissions = ModulePermissionShape<
  typeof structureAssignmentsPermissionKeys
>;
